import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Lock, Loader2, AlertCircle } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/panel");
    } catch (err) {
      setError(err.response?.data?.detail || "Inloggningen misslyckades.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <div className="bg-white border-2 border-gray-300 rounded-xl p-8">
        <h1 className="font-heading text-3xl font-bold text-[#1A1A1A] flex items-center gap-3">
          <Lock size={30} strokeWidth={2.5} className="text-[#0056D2]" /> Administration
        </h1>
        <p className="text-base text-[#4A4A4A] mt-2">Logga in för att hantera manualer.</p>

        <form onSubmit={submit} className="mt-6 space-y-5">
          <div>
            <label className="text-lg font-bold mb-1 block text-[#1A1A1A]">E-post</label>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="min-h-[56px] text-lg px-4 border-2 border-gray-400 rounded-lg w-full focus:border-[#0056D2]" />
          </div>
          <div>
            <label className="text-lg font-bold mb-1 block text-[#1A1A1A]">Lösenord</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="min-h-[56px] text-lg px-4 border-2 border-gray-400 rounded-lg w-full focus:border-[#0056D2]" />
          </div>
          {error && <p data-testid="admin-error" className="flex items-center gap-2 text-[#D32F2F] font-semibold"><AlertCircle size={20} /> {error}</p>}
          <button data-testid="admin-login-btn" type="submit" disabled={loading}
            className="inline-flex items-center justify-center gap-2 min-h-[60px] w-full bg-[#0056D2] text-white text-xl font-bold rounded-lg hover:bg-[#003E99] transition-colors disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={24} /> : null} Logga in
          </button>
        </form>
      </div>
    </div>
  );
}
